export default __webpack_public_path__ + "images/icons/share/url-share-button-ac20f258468f5fb9e4a99f387d6bd30a.svg";